import React from 'react';
import { useApi } from '../../../contexts/ApiContext';
import { Button, Modal } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { Prize } from './prize.type';

type Props = {
  id: number;
  name: Prize['name'];
  onRequestClose: () => void;
}

export const DeletePrize: React.FC<Props> = ({ id, name, onRequestClose }) => {
  const { callApi } = useApi();
  const history = useHistory();

  return (
    <Modal open onClose={onRequestClose} size="mini" >
      <Modal.Header>Delete prize</Modal.Header>
      <Modal.Content>{`Are you sure to delete prize ${name}`}</Modal.Content>
      <Modal.Actions>
        <Button
          negative
          onClick={() => callApi.delete(`/prize/${id}`).then(() => {
            onRequestClose();
            history.go(0);
          })}>Delete</Button>
        <Button onClick={onRequestClose}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
}